<template>
  <div class="app-container">
    <navigation title="主讲人介绍"></navigation>
    <div class="content">
      <van-cell :title="host.name" class="host-cell">
        <template #icon>
<!--          <img :src="baseUrl+host.coverPath" alt="" class="list-img">-->
          <img v-if="host.coverPath" :src="host.coverPath" alt="" class="list-img">
        </template>
      </van-cell>
      <div class="introduce">{{ host.introduce }}</div>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'teacherDetail',
  components: {navigation, version},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      host: ''
    }
  },
  created () {
    this.getMessage()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getMessage () {
      var id = {
        noticeHostId: this.$route.query.id
      }
      request('post', '/nlc-web/api/nlcNotice/noticeHostInfo', id).then(res => {
        console.log('讲师简介', res)
        this.host = res.data
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
  min-height: calc(100% - 92px);
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.tour{
  width:.32rem;
  height:.29rem;
}
.tip{
  color:#C9CBCD;
  text-align:center;
  font-size:.2rem;
  padding: 0 0 .25rem 0;
  line-height:.2rem;
  font-family: SourceHanSansCN-Light;
}
.content{
  width: 6.94rem;
  margin:1.18rem .28rem .16rem .28rem;
  border-radius:8px;
  background:#fff;
  padding:.1rem 0;
}
.van-cell--clickable::after{
  border:0 !important;
}
.van-cell::after{
  border-width: 0;
}
.list-img{
  /*width:1.76rem;*/
  height:1.73rem;
  margin-right:.26rem;
  box-shadow: 6px 4px 10px -6px #000;
}
.introduce{
  font-size:.24rem;
  color:#444649;
  padding:0 .35rem .25rem .35rem;
  line-height:.36rem;
  font-family: SourceHanSerifCN-Regular;
  text-align: justify;
}
.share{
  margin:.3rem;
  color:#444649;
  font-size:.36rem;
}
.share-title{
  font-size:.24rem;
}
.title{
  font-size:.36rem;
  font-family: SourceHanSerifCN-SemiBold;
}
.host-cell >>>.van-cell__title{
  font-family: SourceHanSerifCN-Medium;
}
</style>



// WEBPACK FOOTER //
// src/view/teacherDetail/index.vue